export default __webpack_public_path__ + "static/popup-mobile-x2-825aedecadd7c6b9f2a2a8830ef13b31.jpg";